import React from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import { PRIMARY_COLOR } from "src/components/helper/configuration";
import { SxProps, ButtonProps } from "@mui/material";

type CustomButtonProps = ButtonProps & {
  title: string;
  loading?: boolean;
  sxProps?: SxProps | undefined;
  backgroundColor?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  forceHover?: boolean;
};

export const CustomPrimaryButtonFixed: React.FC<CustomButtonProps> = ({
  title,
  loading,
  sxProps,
  forceHover = false,
  ...props
}: CustomButtonProps) => {
  const hoverColor = PRIMARY_COLOR();

  return (
    <>
      <LoadingButton
        variant="contained"
        color="primary"
        type="submit"
        loading={loading}
        sx={[
          {
            boxShadow: "inset 2px 2px 5px rgba(200, 200, 200, 0.2), 0px 0px 20px rgba(169, 169, 169, 0.3)",
            height: "50px",
            borderRadius: "100px",
            textTransform: "uppercase",
            color: forceHover ? "#fff" : "#fff",
            paddingRight: "26px",
            paddingLeft: "26px",
            fontSize: "18px",
            fontFamily: "Poppins",
            fontWeight: "400",
            border: "2px solid transparent",
            background:
              "linear-gradient(#48007C, #6A0DAD) padding-box, radial-gradient(circle at top center, #ccc 10%, #6A0DAD 50%) border-box",
            transition: "background 0.3s, color 0.3s, box-shadow 0.3s",
            "&:hover": {
              background: "#a44ce2",
              boxShadow: "inset 5px 5px 5px rgba(0, 0, 0, 0.3), 0px 0px 20px rgba(161, 161, 161, 0.9)",
              color: "#fff",
            },
            "@media (max-width: 768px)": {
              width: "100%",
              borderRadius: "0px",
              position: "fixed",
              bottom: 0,
              left: 0,
            },
          },
          ...(Array.isArray(sxProps) ? sxProps : [sxProps]),
        ]}
        {...props}
      >
        {title}
      </LoadingButton>
    </>
  );
};
